import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMathLessThan: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="math-less-than, <"><path fillRule="evenodd" clipRule="evenodd" d="M18.9413 6.45977C18.7809 6.07787 18.3413 5.89831 17.9594 6.05871L5.45939 11.3087C5.18095 11.4257 4.99982 11.6982 4.99982 12.0002C4.99982 12.3022 5.18095 12.5747 5.45939 12.6917L17.9594 17.9417C18.3413 18.1021 18.7809 17.9225 18.9413 17.5406C19.1017 17.1587 18.9221 16.7191 18.5402 16.5587L7.68664 12.0002L18.5402 7.44168C18.9221 7.28128 19.1017 6.84167 18.9413 6.45977Z" fill="currentColor"/></CentralIconBase>;
};

export default IconMathLessThan;
